import 'slick-carousel';
$(".top-bg-slides").slick({
  dots: false,
  arrows: false,
  fade: true,
  infinite: true,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  //variableWidth: true,
  pauseOnHover: false,
  pauseOnFocus: false,
  autoplaySpeed: 4500,
  speed: 1500
})

$(".top-space-slides").slick({
  dots: true,
  arrows: true,
  infinite: true,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  pauseOnHover: false,
  pauseOnFocus: false,
  autoplaySpeed: 4000,
  speed: 800
})

$(".top-gallery-slides").slick({
  dots: true,
  arrows: false,
  infinite: true,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  centerMode: true,
  pauseOnHover: false,
  pauseOnFocus: false,
  autoplaySpeed: 4000,
  speed: 800
})

$(".top-report-slides").slick({
  dots: true,
  arrows: true,
  infinite: true,
  autoplay: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  pauseOnHover: false,
  pauseOnFocus: false,
  autoplaySpeed: 4000,
  speed: 800
})

$(".about-gallery-slides").slick({
  dots: true,
  arrows: false,
  infinite: true,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  centerMode: true,
  pauseOnHover: false,
  pauseOnFocus: false,
  autoplaySpeed: 4000,
  speed: 800
})

$(".temp-ceremony-ceremony-slides").slick({
  dots: true,
  arrows: true,
  infinite: true,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  pauseOnHover: false,
  pauseOnFocus: false,
  autoplaySpeed: 4000,
  speed: 800
})

$(".temp-ceremony-gallery-slides").slick({
  dots: true,
  arrows: false,
  infinite: true,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  centerMode: true,
  pauseOnHover: false,
  pauseOnFocus: false,
  autoplaySpeed: 4000,
  speed: 800
})

$('.suite-pacificsuite-slides').slick({
  dots: true,
  arrows: true,
  infinite: true,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  pauseOnHover: false,
  pauseOnFocus: false,
  autoplaySpeed: 4000,
  speed: 800
})

$('.dress-lineup-slides').slick({
  dots: true,
  arrows: true,
  infinite: true,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  pauseOnHover: false,
  pauseOnFocus: false,
  autoplaySpeed: 4000,
  speed: 800
})

$('.dress-gallery-slides').slick({
  dots: true,
  arrows: true,
  infinite: true,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: true,
  variableWidth: true,
  pauseOnHover: false,
  pauseOnFocus: false,
  autoplaySpeed: 4000,
  speed: 800
})

$('.common-gallery-slides').slick({
  dots: true,
  arrows: true,
  infinite: true,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: true,
  variableWidth: true,
  pauseOnHover: false,
  pauseOnFocus: false,
  autoplaySpeed: 4000,
  speed: 800
})

$('.cuisine-course-slides').slick({
  dots: true,
  arrows: true,
  infinite: true,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  pauseOnHover: false,
  pauseOnFocus: false,
  autoplaySpeed: 4000,
  speed: 800
})

$('.cuisine-restaurant-slides').slick({
  dots: true,
  arrows: true,
  infinite: true,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  pauseOnHover: false,
  pauseOnFocus: false,
  autoplaySpeed: 4000,
  speed: 800
})

$('.cuisine-weddingcake-slides').slick({
  dots: true,
  arrows: true,
  infinite: true,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  pauseOnHover: false,
  pauseOnFocus: false,
  autoplaySpeed: 4000,
  speed: 800
})


let previousWidth = $(window).width();

function toggleSlick() {
  if ($(window).width() <= 1001) {
    if (!$('.about-weddingcontents-slides').hasClass('slick-initialized')) {
      $(".about-weddingcontents-slides").slick({
        dots: true,
        arrows: true,
        infinite: true,
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        autoplaySpeed: 4000,
        speed: 1000
      });
    }
  } else {
    if ($('.about-weddingcontents-slides').hasClass('slick-initialized')) {
      $(".about-weddingcontents-slides").slick('unslick');
    }
  }
}


toggleSlick();


$(window).on('resize', function () {
  let currentWidth = $(window).width();

  if ((previousWidth <= 1000 && currentWidth > 1001) || (previousWidth > 1001 && currentWidth <= 1000)) {
    toggleSlick();
  }

  previousWidth = currentWidth;
});

